(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/service/transactions-service.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/service/transactions-service.js');
"use strict";


const isServer = typeof exports === 'object';
let logger;
let jupiter;
if (isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  jupiter = trinidad.jupiter;
  logger = trinidad.logger('arena');
} else {
  jupiter = svs.core.jupiter;
  logger = svs.arena.logger;
}
const getTransactionsAsync = async opt => {
  const options = {
    syndicateId: opt.syndicateId || undefined,
    transactionTimeUuid: opt.transactionTimeUuid || '',
    count: opt.count || 20
  };
  try {
    let path = "/social/1/syndicates/".concat(options.syndicateId, "/transactions?count=").concat(options.count + 1);
    if (options.transactionTimeUuid !== '') {
      path += "&timeUuidDateFrom=".concat(options.transactionTimeUuid);
    }
    const {
      response
    } = await jupiter.callAsync({
      method: 'GET',
      path,
      data: {}
    });
    logger.debug('transaction-history-service: response from jupiter:', response);
    const hasMoreItems = (response === null || response === void 0 ? void 0 : response.transactions.length) === options.count + 1;
    return {
      error: response === null || response === void 0 ? void 0 : response.error,
      transactions: response === null || response === void 0 ? void 0 : response.transactions.slice(0, options.count),
      hasMoreItems
    };
  } catch (err) {
    logger.warn(err);
    throw err;
  }
};
const exportedFunctions = {
  getTransactionsAsync
};

if (isServer) {
  module.exports = exportedFunctions;
} else {
  svs.arena.service.transactionsService = exportedFunctions;
}

 })(window);